import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

// import p1 from 'assests/Photos/SchoolProgram/2024/orientation/1.jpg';
// import p2 from 'assests/Photos/SchoolProgram/2024/orientation/2.jpg';
// import p3 from 'assests/Photos/SchoolProgram/2024/orientation/3.jpg';
// import p4 from 'assests/Photos/SchoolProgram/2024/orientation/4.jpg';
// import p5 from 'assests/Photos/SchoolProgram/2024/orientation/5.jpg';
// import p6 from 'assests/Photos/SchoolProgram/2024/orientation/6.jpg';


// import p5 from 'assests/Photos/SchoolProgram/2023/Valediction_ceremony/5.jpg';
// import p6 from 'assests/Photos/SchoolProgram/2023/RepublicDay/6.jpg';
// import p7 from 'assests/Photos/SchoolProgram/2023/RepublicDay/7.jpg';
// import p8 from 'assests/Photos/SchoolProgram/2023/RepublicDay/8.jpg';
// import p9 from 'assests/Photos/SchoolProgram/2023/RepublicDay/9.jpg';
// import p10 from 'assests/Photos/SchoolProgram/2023/RepublicDay/10.jpg';


import { Typography } from '@mui/material';
import Container from 'components/Container';
import { Sidebar2023 } from 'views/SchoolProgram2023/components';
import Sidebar2024 from '../SchoolProgram2023/components/Sidebar2024';
import Archive2022 from '../SchoolProgram2023/components/Archive2022';
import { Sidebar2025 } from '../SchoolProgram2023/components';

const Detoxification2025 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const [config, setConfig] = useState({ base_image_url_2025: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2025}/home/events-activities/school-programs/Detoxification/1.webp`;
    const p2 = `${config.base_image_url_2025}/home/events-activities/school-programs/Detoxification/2.webp`;
    const p3 = `${config.base_image_url_2025}/home/events-activities/school-programs/Detoxification/3.webp`;
    const p4 = `${config.base_image_url_2025}/home/events-activities/school-programs/Detoxification/4.webp`;
    const p5  = `${config.base_image_url_2025}/home/events-activities/school-programs/Detoxification/5.webp`;
    const p6  = `${config.base_image_url_2025}/home/events-activities/school-programs/Detoxification/6.webp`;

    
    
   
    const photos = [
 {
  src: p1,
  source: p1,
  rows: 1,
  cols: 1,
},
{
  src: p2,
  source: p2,
  rows: 1,
  cols: 1,
},
{
  src: p3,
  source: p3,
  rows: 1,
  cols: 1,
}, 
{
  src: p4,
  source: p4,
  rows: 1,
  cols: 1,
},
{
  src: p5,
  source: p5,
  rows: 1,
  cols: 1,
},
{
  src: p6,
  source: p6,
  rows: 1,
  cols: 1,
}
    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h5' align='center'>
                              Digital Detoxing and Social Conditioning 
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                               Class: 7 - 9      Date: 18 December 2025
                                </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “If you believe in yourself and have dedication and determination and never quit, you'll be a winner. The price of victory is high but so are the rewards.”

                                <br />
                            </Typography> */}

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                               A highly engaging session on <strong>Digital Detoxing and Social Conditioning</strong> was conducted for students of <strong>Classes VII to IX on Thursday, 18 December 2025, by Dr. Gayathri K.</strong> The session aimed to create awareness about the growing impact of excessive screen time on students’ physical, mental and emotional well-being.
                                <br></br>
                               Dr Gayathri K highlighted key concerns such as eye strain, disturbed sleep patterns, reduced attention span and social isolation caused by prolonged digital exposure. She emphasised the importance of cultivating healthy social habits, mindful technology use and maintaining a balance between the digital world and real-life interactions.
                                <br></br>
                               The session was interactive and student-centric, featuring discussions, thought-provoking questions and practical activities that encouraged self-reflection on daily screen usage. Students actively participated by sharing their experiences and exploring simple strategies such as setting screen-time limits, engaging in outdoor activities, practising face-to-face communication and developing hobbies beyond digital devices.
                               The program also stressed the role of self-discipline, family interaction and peer bonding in building a healthier lifestyle. Students were motivated to make conscious choices regarding technology use and to prioritise meaningful social connections.
                                <br></br>
                               Overall, the session was <strong>informative, engaging and inspiring,</strong> leaving students with valuable insights and practical takeaways. It successfully reinforced the school’s commitment to promoting digital well-being and holistic development among students.
                               <br></br>
                                </Typography>
                            </Box>
                            {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “Detoxification is not just a language, it’s the expression of our soul”

                                <br />
                            </Typography> */}

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 300 : 200}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <Sidebar2025/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default Detoxification2025;